import React from "react";
import { useTranslation } from "react-i18next";
import { YearSelector } from "../dates/YearSelector";
import dayjs from "dayjs";

const BeanYearSelector = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();

  return (
    <YearSelector
      views={["year"]}
      openTo="year"
      minDate={dayjs("2000-01-01")}
      maxDate={dayjs("2030-12-31")}
      value={value ? dayjs(value) : null}
      onChange={onChange}
      placeholder={t('beens.productionyear')}
    />
  );
};

export default BeanYearSelector;
